import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

export const InfoRow = ({ label, value }) => {
    const isEmail = label === "Email";

    return (
      <MDBox>
        <MDTypography
          variant="button"
          fontWeight="bold"
          textTransform={isEmail ? "none" : "capitalize"}
          mr={1}
        >
          {label}:
        </MDTypography>
        {isEmail ? (
          <MDTypography
            variant="button"
            fontWeight="regular"
            color="info"
            component="a"
            href={`mailto:${value}`}
          >
            {value || "NA"}
          </MDTypography>
        ) : (
          <MDTypography variant="button" fontWeight="regular" color="text">
            {value || "NA"}
          </MDTypography>
        )}
      </MDBox>
    );
  };